module.exports = __webpack_public_path__ + "static/media/AvenirNext200.af3e0a80.woff";